/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Faq_TitleInputs */

const en_meta_faq_title = /** @type {(inputs: Meta_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Automation FAQ: AI Agents, RAG, n8n and Cost | Lindevo`)
};

const lv_meta_faq_title = /** @type {(inputs: Meta_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BUJ par AI automatizāciju: AI aģenti, RAG, n8n | Lindevo`)
};

/**
* | output |
* | --- |
* | "AI Automation FAQ: AI Agents, RAG, n8n and Cost \| Lindevo" |
*
* @param {Meta_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_faq_title = /** @type {((inputs?: Meta_Faq_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Faq_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_faq_title(inputs)
	return en_meta_faq_title(inputs)
});